import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#0F0F0F] border-t border-gray-800 mt-16">
      <div className="container mx-auto px-4 py-12">
        <div className="text-center md:text-start grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8">
          <div>
            <h3 className="text-white font-semibold mb-4">Accueil</h3>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/" className="hover:text-white transition">Accueil</Link></li>
              <li><Link to="/support" className="hover:text-white transition">Support</Link></li>
              <li><Link to="/subscriptions" className="hover:text-white transition">Tarifs</Link></li>
              <li><Link to="/support" className="hover:text-white transition">FAQ</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">Films</h3>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/movies" className="hover:text-white transition">Genres</Link></li>
              <li><Link to="/movies" className="hover:text-white transition">Tendances</Link></li>
              <li><Link to="/movies" className="hover:text-white transition">Nouveautés</Link></li>
              <li><Link to="/movies" className="hover:text-white transition">Populaire</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">Séries</h3>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/movies" className="hover:text-white transition">Genres</Link></li>
              <li><Link to="/movies" className="hover:text-white transition">Tendances</Link></li>
              <li><Link to="/movies" className="hover:text-white transition">Nouveautés</Link></li>
              <li><Link to="/movies" className="hover:text-white transition">Populaire</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">Support</h3>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/support" className="hover:text-white transition">Contactez-nous</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-white font-semibold mb-4">Abonnement</h3>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/subscriptions" className="hover:text-white transition">Plans</Link></li>
              <li><Link to="/subscriptions" className="hover:text-white transition">Fonctionnalités</Link></li>
            </ul>
          </div>
          
          <div className='flex items-start flex-col'>
            <h3 className="text-white font-semibold mb-4">Contactez-nous</h3>
            <a 
              href="https://t.me/H4_STREAM" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-[#1A1A1A] p-3 rounded-lg border border-[#262626] flex items-center justify-start hover:bg-[#252525] hover:border-blue-500/50 transition-all cursor-pointer"
            >
              <svg width="24" height="21" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M18.384 20.7681C18.706 21.0075 19.121 21.0674 19.491 20.9204C19.8609 20.7723 20.1329 20.4405 20.2149 20.0384C21.0839 15.7502 23.1919 4.89631 23.9829 0.995557C24.0429 0.701556 23.9429 0.396006 23.7229 0.199656C23.5029 0.00330571 23.1979 -0.0533945 22.9259 0.0526557C18.733 1.68226 5.82027 6.76951 0.542386 8.82016C0.207393 8.95036 -0.0106019 9.28847 0.000397843 9.65912C0.0123976 10.0308 0.250392 10.3532 0.593384 10.4613C2.96033 11.2047 6.06726 12.239 6.06726 12.239C6.06726 12.239 7.51923 16.8432 8.27621 19.1847C8.37121 19.4787 8.5902 19.7097 8.8792 19.7895C9.16719 19.8683 9.47518 19.7853 9.69018 19.5722C10.9061 18.3668 12.7861 16.503 12.7861 16.503C12.7861 16.503 16.358 19.253 18.384 20.7681ZM7.37423 11.6573L9.05319 17.4722L9.42618 13.7898C9.42618 13.7898 15.913 7.64626 19.611 4.14451C19.719 4.04161 19.7339 3.86941 19.644 3.74866C19.555 3.62791 19.391 3.59956 19.268 3.68146C14.9821 6.55531 7.37423 11.6573 7.37423 11.6573Z" fill="white"/>
              </svg>
            </a>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">© 2026 H4KIGSTREAM. All rights reserved.</p>
          <div className="flex space-x-4 mt-4 md:mt-0">
            <Link to="/terms" className="text-gray-400 hover:text-white text-sm transition">Conditions d'utilisation</Link>
            <Link to="/privacy" className="text-gray-400 hover:text-white text-sm transition">Politique de confidentialité</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
